import { FC, memo, useEffect } from 'react';
import { isNil } from 'lodash';
// Import UI Components
import { BusyLoader } from '@geneui/components';
// Import Components
import CJBlockInfoSidebarOptionList from 'components/CustomerJourney/CJBlockInfoSidebarOptionList';
// Import Context
import { useCJWorkflowBlocks } from 'context/cjWorkflowBlocksContext';
// Import Constants
import { l } from 'constants/common';

interface Props {
    blockName: string;
}

const BonusBlockConfiguration: FC<Props> = ({ blockName }) => {
    const { ensureSchemaLoaded, isSchemaLoading, getBlockConfiguration } = useCJWorkflowBlocks();

    // Kick off the one-time schema fetch when the row is expanded.
    useEffect(() => {
        ensureSchemaLoaded();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const blockConfiguration = getBlockConfiguration(blockName);

    return (
        <BusyLoader isBusy={isSchemaLoading} type="spinner" spinnerSize="medium">
            {!isNil(blockConfiguration) && (
                <CJBlockInfoSidebarOptionList
                    blockId={blockConfiguration.blockId}
                    options={blockConfiguration.options}
                    apiModel={blockConfiguration.apiModel}
                    elements={blockConfiguration.elements}
                    sectionTitle={l.BonusConfiguration}
                />
            )}
        </BusyLoader>
    );
};

export default memo(BonusBlockConfiguration);
